module.exports = __webpack_public_path__ + "assets/2b61c453a32c74ad8436844cb12865b8.mp3";